import axios from './axiosConfig';
import { CookieNames, getCookie } from '../helpers/cookie.helper';
import { getBoolean } from '../helpers/index.helper';

export const insertUpdateSubscriptionPlan = async (data) => {
    try {
        const response = await axios.post(`/api/Subscriptionplan/InsertUpdateSubscriptionplans?SessionId=${getCookie(CookieNames.SESSION_ID)}`, data);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getSubscriptionPlanDetails = async (planId) => {
    try {
        const response = await axios.get(`/api/Subscriptionplan/GetSubscriptionplanDetails`, {
            params: {
                SessionId: getCookie(CookieNames.SESSION_ID),
                Id: planId
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const listSubscriptionPlans = async (pageIndex, pageSize, searchText, isActive = '', includeAll = false) => {
    try {
        const response = await axios.get(`/api/Subscriptionplan/GetSubscriptionplanList`, {
            params: {
                SessionId: getCookie(CookieNames.SESSION_ID),
                PageIndex: pageIndex,
                PageSize: pageSize,
                SearchText: searchText,
                IsActive: isActive,
                IncludeAll: includeAll
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const toggleSubscriptionPlanStatus = async (planId, isActive, type = '') => {
    try {
        const response = await axios.post(`/api/Subscriptionplan/ActiveInActiveDeleteSubscriptionplans`, {}, {
            params: {
                SessionId: getCookie(CookieNames.SESSION_ID),
                Id: planId,
                Type: type,
                Status: getBoolean(isActive) ? 1 : 0,
                UserId: getCookie(CookieNames.USER_ID)
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}